import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from './components/HeroBanner';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdate from './components/LatestUpdate';
import RankingList from './components/RankingList';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '香蕉漫画网',
    url: 'https://bananamanga.com',
    description: '香蕉漫画网汇聚海量漫画免费阅读资源，免费漫画大全、免费看漫画、免费更新一应俱全，零成本畅享全本漫画。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://bananamanga.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '香蕉漫画网',
    url: 'https://bananamanga.com',
    description: '免费在线漫画阅读平台，提供海量漫画免费阅读资源。',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <Navbar />
      <main>
        <HeroBanner />
        <HotRecommend />
        <CategoryNav />
        <LatestUpdate />
        <RankingList />
      </main>
      <Footer />
    </>
  );
}